import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { carouselSlides } from "@/mocks/home";

export default function HeroCarousel() {
  const [active, setActive] = useState(0);
  const total = carouselSlides.length;

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % total);
    }, 5000);
    return () => window.clearInterval(timer);
  }, [total]);

  const goTo = (index: number) => setActive(((index % total) + total) % total);

  return (
    <section className="relative w-full overflow-hidden rounded-lg bg-foreground-950">
      <div className="relative h-[300px] w-full sm:h-[380px] lg:h-[440px]">
        {carouselSlides.map((slide, index) => (
          <Link
            key={slide.id}
            to={`/detail/${slide.targetId}`}
            className={`absolute inset-0 block transition-opacity duration-700 ${
              index === active ? "opacity-100" : "pointer-events-none opacity-0"
            }`}
            aria-hidden={index !== active}
            tabIndex={index === active ? 0 : -1}
          >
            <img
              src={slide.image}
              alt={slide.title}
              title={`${slide.title} - 天天干天天干`}
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/10"></div>
            <div className="absolute inset-x-0 bottom-0 flex flex-col items-start gap-3 p-6 md:p-10">
              <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                {slide.tag}
              </span>
              <h2 className="max-w-2xl text-xl font-bold leading-snug text-white md:text-3xl">
                {slide.title}
              </h2>
              <p className="max-w-xl text-sm text-white/80 md:text-base">{slide.subtitle}</p>
              <span className="mt-1 inline-flex items-center gap-1 rounded-full bg-background-50 px-4 py-2 text-sm font-medium text-foreground-950">
                查看详情
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>

      <button
        type="button"
        onClick={() => goTo(active - 1)}
        aria-label="上一张"
        className="absolute left-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-black/30 text-white transition-colors hover:bg-black/50 md:left-6 md:h-10 md:w-10"
      >
        <i className="ri-arrow-left-s-line text-xl" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        onClick={() => goTo(active + 1)}
        aria-label="下一张"
        className="absolute right-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-black/30 text-white transition-colors hover:bg-black/50 md:right-6 md:h-10 md:w-10"
      >
        <i className="ri-arrow-right-s-line text-xl" aria-hidden="true"></i>
      </button>

      <div className="absolute bottom-4 right-6 flex items-center gap-2">
        {carouselSlides.map((slide, index) => (
          <button
            key={slide.id}
            type="button"
            onClick={() => goTo(index)}
            aria-label={`切换到第 ${index + 1} 张`}
            className={`h-2 rounded-full transition-all ${
              index === active ? "w-6 bg-primary-500" : "w-2 bg-white/60"
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}